export enum CampaignAnalyticEventTypeEnum {
  CAMPAIGN_ACTIVATED = 'CAMPAIGN_ACTIVATED',
  CAMPAIGN_DEACTIVATED = 'CAMPAIGN_DEACTIVATED',
  CAMPAIGN_DEACTIVATED_AUTO = 'CAMPAIGN_DEACTIVATED_AUTO',
  BANNER_SHOWN = 'BANNER_SHOWN',
  BANNER_CLICKED = 'BANNER_CLICKED',

  // email opens are tracked in notification_queue_processed
  EMAIL_LINK_CLICKED = 'EMAIL_LINK_CLICKED',
  TOPIC_SHARE_LINK_CLICKED = 'TOPIC_SHARE_LINK_CLICKED',
  PATHWAY_SHARE_LINK_CLICKED = 'PATHWAY_SHARE_LINK_CLICKED',
  SURVEY_SHARE_LINK_CLICKED = 'SURVEY_SHARE_LINK_CLICKED'
}

export enum CampaignUserEventTypeEnum {
  join = 'join',
  leave = 'leave',
  completed = 'completed'
}

export enum CampaignFilterTypeEnum {
  value_comparison = 'value_comparison',
  duration_comparison = 'duration_comparison',
  group = 'group',
  workspace = 'workspace',
  topic_enrolment = 'topic_enrolment',
  pathway_enrolment = 'pathway_enrolment',
  certification_enrolment = 'certification_enrolment',
  event_invitation = 'event_invitation'
}

export enum CampaignSearchableUserAttribute {
  'email' = 'email',
  'account_name' = 'account_name',
  'display_name' = 'display_name',
  'first_name' = 'first_name',
  'last_name' = 'last_name',
  'position' = 'position',
  'timezone' = 'timezone',
  'employee_id' = 'employee_id',
  'area' = 'area',
  'location' = 'location',
  'department' = 'department',
  'custom_1' = 'custom_1',
  'custom_2' = 'custom_2',
  'custom_3' = 'custom_3',
  'phone_number' = 'phone_number',
  'manager_email' = 'manager_email',
  'locale' = 'locale'
}

export enum EnrolmentTargetTypeEnum {
  topic = 'topic',
  pathway = 'pathway',
  certification = 'certification'
}

export enum CampaignActionTypeEnum {
  EMAIL = 'EMAIL',
  BANNER = 'BANNER',
  TOPIC_SHARE_ACTION = 'TOPIC_SHARE_ACTION',
  PATHWAY_SHARE_ACTION = 'PATHWAY_SHARE_ACTION',
  SURVEY_SHARE_ACTION = 'SURVEY_SHARE_ACTION',
  MESSAGE = 'MESSAGE',
  CERTIFICATION_SHARE_ACTION = 'CERTIFICATION_SHARE_ACTION',
  MANAGER_NOTIFICATION = 'MANAGER_NOTIFICATION'
}
